import React, { useContext } from 'react';
import { CartContext } from '../App';
import './Cart.css';

export default function Cart() {
  const { cartItems, cartOpen, setCartOpen, removeFromCart, updateQty } = useContext(CartContext);

  const total = cartItems.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <>
      <div className={`cart-overlay ${cartOpen ? 'open' : ''}`} onClick={() => setCartOpen(false)} />
      <div className={`cart-drawer ${cartOpen ? 'open' : ''}`}>
        <div className="cart-header">
          <h2>Your Bag <span>({cartItems.length})</span></h2>
          <button onClick={() => setCartOpen(false)} className="cart-close">✕</button>
        </div>

        {cartItems.length === 0 ? (
          <div className="cart-empty">
            <div className="empty-icon">🛍️</div>
            <p>Your bag is empty</p>
            <button className="btn-primary" onClick={() => setCartOpen(false)}>Continue Shopping</button>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {cartItems.map(item => (
                <div key={item.id} className="cart-item">
                  <img src={item.image} alt={item.name} />
                  <div className="item-info">
                    <h4>{item.name}</h4>
                    <p className="item-category">{item.category}</p>
                    <p className="item-price">₹{item.price.toLocaleString()}</p>
                    <div className="item-controls">
                      <button onClick={() => updateQty(item.id, item.qty - 1)}>−</button>
                      <span>{item.qty}</span>
                      <button onClick={() => updateQty(item.id, item.qty + 1)}>+</button>
                    </div>
                  </div>
                  <button className="remove-btn" onClick={() => removeFromCart(item.id)}>✕</button>
                </div>
              ))}
            </div>

            <div className="cart-footer">
              <div className="cart-total">
                <span>Total</span>
                <span>₹{total.toLocaleString()}</span>
              </div>
              <button className="btn-checkout">Proceed to Checkout</button>
              <p className="free-shipping">✓ Free shipping on orders above ₹5,000</p>
            </div>
          </>
        )}
      </div>
    </>
  );
}
